import { emptyFilters } from "./CollectionOverviewFilter";
export const defaultPagination = {
    limit: 10,
    offset: 0
};
export const initialSearchParams = {
    ...emptyFilters,
    ...defaultPagination
};
